<template>
  <div style="padding-top:100px;">
    <el-form
      class="systemFont2 systemForm1"
      ref="basicCompanyInformationRef"
      :model="basicCompanyInformationFrom"
      label-width="110px"
      hide-required-asterisk
      :rules="rules"
    >
      <el-row>
        <!-- 第一列 -->
        <el-col :span="9" :offset="1">
          <!-- 注册名称 -->
          <el-form-item :label="$t('p0204.registeredName')" prop="companyName">
            <el-input
              v-model="basicCompanyInformationFrom.companyName"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 简称 -->
          <el-form-item :label="$t('p0204.shortName')">
            <el-input
              v-model="basicCompanyInformationFrom.companyAbbrName"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 注册地 -->
          <el-form-item :label="$t('p0204.registration')">
            <!-- 省 -->
            <el-col :span="8">
              <el-col :span="22">
                <el-autocomplete
                  :disabled="editSave"
                  size="reportContentInput"
                  popper-class="localeSelect"
                  :popper-append-to-body="false"
                  v-model="basicCompanyInformationFrom.province"
                  :placeholder="$t('p0204.province')"
                  :fetch-suggestions="querySearchProvince"
                  style="width: 100%"
                  @select="handleSelectProvince"
                  clearable
                  @change="provinceChange"
                  @clear="clearProvince"
                ></el-autocomplete></el-col
            ></el-col>
            <!-- 市 -->
            <el-col :span="8">
              <el-col :span="22" :offset="1">
                <el-autocomplete
                  popper-class="localeSelect"
                  size="reportContentInput"
                  :popper-append-to-body="false"
                  v-model="basicCompanyInformationFrom.city"
                  :placeholder="$t('p0204.city')"
                  :fetch-suggestions="querySearchCity"
                  style="width: 100%"
                  @select="handleSelectcity"
                  @change="cityChange"
                  clearable
                  @clear="clearCity"
                  :disabled="
                    editSave || basicCompanyInformationFrom.province == ''
                  "
                ></el-autocomplete> </el-col
            ></el-col>
            <!-- 区 -->
            <el-col :span="8">
              <el-col :span="22" :offset="2">
                <el-autocomplete
                  popper-class="localeSelect"
                  size="reportContentInput"
                  :popper-append-to-body="false"
                  v-model="basicCompanyInformationFrom.area"
                  :placeholder="$t('p0204.area')"
                  :fetch-suggestions="querySearchArea"
                  style="width: 100%"
                  @change="areaChange"
                  clearable
                  @clear="clearArea"
                  :disabled="editSave || basicCompanyInformationFrom.city == ''"
                ></el-autocomplete> </el-col
            ></el-col>
          </el-form-item>
          <!-- 注册地址 -->
          <el-form-item :label="$t('p0204.registeredAddress')">
            <el-input
              v-model="basicCompanyInformationFrom.registeredAddress"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 联系电话 -->
          <el-form-item :label="$t('p0204.contactNumber')">
            <!-- 区号 -->
            <el-col :span="8">
              <el-select
                v-model="basicCompanyInformationFrom.areaCode"
                :disabled="editSave"
                placeholder=""
                size="reportContentInput"
                filterable
              >
                <el-option
                  v-for="item in phoneAreaList"
                  :key="item.phoneAreaId"
                  :label="item.dialCode"
                  :value="item.dialCode"
                >
                </el-option>
              </el-select>
            </el-col>
            <!-- 电话号 -->
            <el-col :span="15" :offset="1">
              <el-form-item label-width="0" prop="telephoneNumber">
                <el-input
                  v-model="basicCompanyInformationFrom.telephoneNumber"
                  size="reportContentInput"
                  :disabled="editSave"
                  maxlength="125"
                ></el-input
              ></el-form-item>
            </el-col>
          </el-form-item>
          <!-- 联系地址 -->
          <el-form-item :label="$t('p0204.contactAddress')">
            <el-input
              v-model="basicCompanyInformationFrom.contactAddress"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 所属行业 -->
          <el-form-item :label="$t('p0204.industry')">
            <el-col :span="24">
              <el-select
                size="reportContentInput"
                v-model="basicCompanyInformationFrom.industry"
                :placeholder="$t('p0201.industryName')"
                :disabled="editSave"
                style="width:100%"
              >
                <el-option
                  v-for="item in industry"
                  :key="item.codeKey"
                  :label="item.codeValueZh"
                  :value="item.codeValueZh"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <!-- 第二列 -->
        <el-col :span="9" :offset="4">
          <!-- 公司税号 -->
          <el-form-item :label="$t('p0204.companyTaxNumber')">
            <el-input
              v-model="basicCompanyInformationFrom.companyTaxNumber"
              size="reportContentInput"
              :disabled="true"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 注册国家/地区 -->
          <el-form-item :label="$t('p0204.countryOfRegistration')">
            <el-col :span="24">
              <el-select
                size="reportContentInput"
                v-model="basicCompanyInformationFrom.country"
                :placeholder="$t('p0201.industryName')"
                :disabled="true"
                style="width:100%"
              >
                <el-option
                  v-for="item in country"
                  :key="item.codeKey"
                  :label="item.codeValueZh"
                  :value="item.codeValueZh"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <!-- 英文名称 -->
          <el-form-item :label="$t('p0204.englishName')">
            <el-input
              v-model="basicCompanyInformationFrom.enName"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 公司代表/联系人 -->
          <el-form-item :label="$t('p0204.companyRepresentativeContact')">
            <el-input
              v-model="basicCompanyInformationFrom.companyContacts"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 公司网址 -->
          <el-form-item :label="$t('p0204.companyWebsite')">
            <el-input
              v-model="basicCompanyInformationFrom.companyWebsite"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item :label="$t('p0204.remark')">
            <el-input
              v-model="basicCompanyInformationFrom.remarks"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 公司资料 -->
          <el-form-item :label="$t('p0204.companyInformation')">
            <!-- <el-input
              v-model="basicCompanyInformationFrom.file_path_id"
              size="reportContentInput"
              :disabled="editSave"
              maxlength="125"
            ></el-input> -->
            <el-col :span="6">
              <uploadFile
                v-if="uploadFileReloadFlag"
                ref="UploadFileRef"
                :uploadButtonStyle="uploadButtonStyle"
                :uploadFile="{
                  uploadBtnDisplayFlag: true,
                  locationCode: basicCompanyInformationFrom.filePathId
                }"
                :uploadDisable="editSave"
              >
              </uploadFile>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="foot-container">
      <el-col v-show="editSave" :span="12">
        <!-- 编辑 -->
        <el-button type="submit" @click.native.prevent="editor">{{
          $t("p0204.edit")
        }}</el-button>
      </el-col>
      <el-col v-show="!editSave" :span="12">
        <!-- 保存 -->
        <el-button type="submit" @click.native.prevent="handleSubmit">{{
          $t("p0204.save")
        }}</el-button>
      </el-col>
      <!-- 返回 -->
      <el-col :span="12">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import qs from "qs";
import uploadFile from "../../components/Common/UploadAttachment.vue";
import { build20Id } from "../../utils/buildId.js";
import moment from "moment";
export default {
  components: {
    uploadFile
  },
  data() {
    let p0202 = JSON.parse(sessionStorage.getItem("p0202"));
    return {
      // 公司ID
      mCompanyId: p0202.mCompanyId,
      // 表单数据
      basicCompanyInformationFrom: {},
      // 保存编辑按钮
      editSave: true,
      // 写入手机区号
      phoneAreaList: [],
      provinces: [],
      cities: [],
      chineArea: [],
      // 行业获取下拉框
      industry: [],
      //获取国家
      country: [],
      areas: [],
      uploadButtonStyle: 1,
      oldCompanyName: "",
      // 上传按钮控件是否显示按钮（重新加载用）
      uploadFileReloadFlag: true,
      rules: {
        companyName: [
          {
            required: true,
            message: this.$t("p0204.canNotBeEmpty"),
            trigger: "blur"
          }
        ],
        telephoneNumber: [
          {
            required: false,
            // 请输入手机
            message: this.$t("p0204.pleaseEnterYourPhone"),
            trigger: "blur"
          },
          {
            pattern: /(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            // 手机格式错误
            message: this.$t("p0204.wrongPhoneFormat"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    async upload() {
      await this.$refs.UploadFileRef.submitUploadFile();
    },
    // 编辑按钮
    editor() {
      this.editSave = false;
      // 上传按钮显示
      this.changeUploadFileStatus();
    },
    // 改变上传文件的状态
    changeUploadFileStatus() {
      this.reloadUploadFile();
    },
    // 重新加载上传附件控件
    async reloadUploadFile() {
      this.uploadFileReloadFlag = false;
      await this.$nextTick();
      this.uploadFileReloadFlag = true;
    },
    // 获取国家下拉框
    getCountry() {
      let url = "/api/companyOrganizationCustomers/getCountry";
      let params = {};
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.country = response.data.data;
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取行业下拉框
    getIndustry() {
      let url = "/api/companyOrganizationCustomers/getIndustry";
      let params = {};
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.industry = response.data.data;
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取中国城市
    getChineArea() {
      let url = "/api/companyOrganizationCustomers/getChineArea";
      let params = {};
      this.$http
        .post(url, qs.stringify(params))
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            // 所有中国城市
            this.chineArea = response.data.data;
            // 省
            for (var i = 0; i < this.chineArea.length; i++) {
              if (this.chineArea[i].vcCode.length == 10) {
                this.provinces.push(this.chineArea[i]);
              }
            }
            this.$nextTick(() => {
              // 市 判断是否存在该省份
              if (
                this.selectProvincesCodeByName(
                  this.basicCompanyInformationFrom.province
                )
              ) {
                // 加载市
                let proCode = this.selectProvincesCodeByName(
                  this.basicCompanyInformationFrom.province
                );
                for (var i = 0; i < this.chineArea.length; i++) {
                  if (
                    proCode === this.chineArea[i].vcCode.substring(0, 10) &&
                    this.chineArea[i].vcCode.length == 12
                  ) {
                    this.cities.push(this.chineArea[i]);
                  }
                }
              } else {
                this.cities = [];
              }
              console.log("🚀cities", this.cities);
              // 区 判断是否存在该区
              if (
                this.selectareasCodeByName(
                  this.basicCompanyInformationFrom.city
                )
              ) {
                // 加载区
                let proCodeArea = this.selectareasCodeByName(
                  this.basicCompanyInformationFrom.city
                );
                for (var i = 0; i < this.chineArea.length; i++) {
                  if (
                    proCodeArea === this.chineArea[i].vcCode.substring(0, 12) &&
                    this.chineArea[i].vcCode.length == 14
                  ) {
                    this.areas.push(this.chineArea[i]);
                  }
                }
              } else {
                this.areas = [];
              }
              console.log("🚀areas", this.areas);
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 加载市
    getCityOrRegionData(val) {
      this.cities = [];
      this.basicCompanyInformationFrom.city = "";
      for (var i = 0; i < this.chineArea.length; i++) {
        if (
          val === this.chineArea[i].vcCode.substring(0, 10) &&
          this.chineArea[i].vcCode.length == 12
        ) {
          this.cities.push(this.chineArea[i]);
        }
      }
    },
    // 加载区
    getAreasData(val) {
      this.areas = [];
      this.basicCompanyInformationFrom.area = "";
      for (var i = 0; i < this.chineArea.length; i++) {
        if (
          val === this.chineArea[i].vcCode.substring(0, 12) &&
          this.chineArea[i].vcCode.length == 14
        ) {
          this.areas.push(this.chineArea[i]);
        }
      }
    },
    // 初始化
    init() {
      let url = "/api/companyOrganizationCustomers/basicCompanyInformation";
      this.$http
        .post(url, {
          mCompanyId: this.mCompanyId
        })
        .then(response => {
          if (response.data.code === 200) {
            this.basicCompanyInformationFrom = response.data.data;
            this.phoneAreaList = response.data.data.phoneAreas;
            this.oldCompanyName = this.basicCompanyInformationFrom.companyName;
            console.log(this.basicCompanyInformationFrom.filePathId);
            if (
              this.basicCompanyInformationFrom.filePathId == null ||
              this.basicCompanyInformationFrom.filePathId == "" ||
              typeof this.basicCompanyInformationFrom.filePathId == "undefined"
            ) {
              this.basicCompanyInformationFrom.filePathId = build20Id();
            }
            this.reloadUploadFile();
            this.getChineArea();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },

    // 提交
    handleSubmit() {
      this.$refs["basicCompanyInformationRef"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          this.upload();
          let url =
            "/api/companyOrganizationCustomers/basicCompanyInformationSave";
          this.basicCompanyInformationFrom.mCompanyId = this.mCompanyId;
          this.basicCompanyInformationFrom.updateUserId = localStorage.getItem(
            "userId"
          );
          this.basicCompanyInformationFrom.nameChangeSign =
            this.basicCompanyInformationFrom.companyName ===
            this.oldCompanyName;
          this.$http
            .post(url, this.basicCompanyInformationFrom)
            .then(response => {
              if (response.data.code === 200) {
                console.log(response.data.data);
                this.getChineArea();
                this.editSave = true;
                this.uploadFileReloadFlag = false;
                this.$nextTick();
                this.uploadFileReloadFlag = true;
                loading.close();
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },

    // 返回
    handleReturn() {
      sessionStorage.setItem("detailCo", true);
      this.$router.go(-1);
    },

    // 根据名称查地域编号
    selectProvincesCodeByName(locate) {
      console.log(locate);
      let provList = this.provinces.filter(item => {
        return item.vcName === locate;
      });
      if (provList.length > 0) {
        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 根据名称查地域编号
    selectareasCodeByName(locate) {
      console.log(locate);
      let provList = this.cities.filter(item => {
        return item.vcName === locate;
      });
      if (provList.length > 0) {
        return provList[0].vcCode;
      } else {
        return null;
      }
    },
    // 查城市编号
    selectCityCodeByName(locate) {
      return this.cities.filter(item => {
        return item.vcName === locate;
      })[0].vcCode;
    },
    // 手动输入省份，前缀过滤选择列表
    querySearchProvince(queryString, callback) {
      var provinces = this.provinces;
      var results = queryString
        ? provinces.filter(province => {
            return (
              province.vcName
                .toLowerCase()
                .indexOf(queryString.toLowerCase()) === 0
            );
          })
        : provinces;
      // console.log(results)

      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },

    // 手动输入省份改变事件
    provinceChange(province) {
      // 清除区域
      this.basicCompanyInformationFrom.city = "";
      this.basicCompanyInformationFrom.area = "";
      // 判断是否存在该省份
      if (this.selectProvincesCodeByName(province)) {
        // 加载城市列表
        this.handleSelectProvince({ value: province });
      } else {
        this.cities = [];
      }
    },
    // 城市改变清除区域
    cityChange(city) {
      this.basicCompanyInformationFrom.area = "";
      // 判断是否存在该区
      if (this.selectareasCodeByName(city)) {
        // 加载区
        this.handleSelectcity({ value: city });
      } else {
        this.areas = [];
      }
    },
    areaChange(area) {
      this.basicCompanyInformationFrom.area = "";
    },
    // 选择省份时加载市
    handleSelectProvince(province) {
      let proCode = this.selectProvincesCodeByName(province.value);
      this.getCityOrRegionData(proCode);
    },
    // 选择市时加载区
    handleSelectcity(city) {
      let proCode = this.selectareasCodeByName(city.value);
      this.getAreasData(proCode);
    },
    // 清除省份时清除市、区域
    clearProvince() {
      this.basicCompanyInformationFrom.province = "";
      this.basicCompanyInformationFrom.city = "";
      this.basicCompanyInformationFrom.area = "";
    },
    // 清除市时清除区域
    clearCity() {
      this.basicCompanyInformationFrom.city = "";
      this.basicCompanyInformationFrom.area = "";
      this.provinceChange(this.basicCompanyInformationFrom.province);
    },
    // 清除区域
    clearArea() {
      this.basicCompanyInformationFrom.area = "";
      let proCode = this.selectProvincesCodeByName(
        this.basicCompanyInformationFrom.province
      );
      for (var i = 0; i < this.chineArea.length; i++) {
        if (
          proCode === this.chineArea[i].vcCode.substring(0, 10) &&
          this.chineArea[i].vcCode.length == 12
        ) {
          this.cities.push(this.chineArea[i]);
        }
      }
      this.cityChange(this.basicCompanyInformationFrom.city);
    },
    // 手动输入城市，前缀过滤列表
    querySearchCity(queryString, callback) {
      var cities = this.cities;
      var results = queryString
        ? cities.filter(city => {
            return (
              city.vcName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            );
          })
        : cities;
      // console.log('cityResult',results)
      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },

    // 手动输入地区，前缀过滤列表
    querySearchArea(queryString, callback) {
      var areas = this.areas;
      var results = queryString
        ? areas.filter(area => {
            return (
              area.vcName.toLowerCase().indexOf(queryString.toLowerCase()) === 0
            );
          })
        : areas;
      // console.log('cityResult',results)
      callback(
        results.map(item => {
          return { value: item.vcName };
        })
      );
    },
    // 国家适配中文
    checkCountry() {
      // alert(1)
      if (localStorage.locale === "zh") {
        // alert(2)
        if (this.basicCompanyInformationFrom.conuntry === "China") {
          // alert(3)
          this.basicCompanyInformationFrom.conuntry = "中国";
        }
      }
    }
  },
  mounted() {
    this.init();
    this.getIndustry();
    this.getCountry();
  }
};
</script>

<style lang="scss" scoped>
.foot-container {
  margin: 50px auto 0 auto;
  margin-bottom: 50px;
  height: 26px;
  width: 14%;
  text-align: center;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}

// 加号图标的样式
.add-icon {
  float: left;
  position: relative;
  top: 13px;
  left: 10px;
  cursor: pointer;
}

// 减号图标的样式
.subtract-icon {
  float: left;
  position: relative;
  top: 18px;
  left: 9px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0204.vue